import { useLocation } from "react-router-dom";
import { InvitationHeader } from "./InvitationHeader";
import { useInvitation } from "@platform/store";
import { INVITATION_TYPE } from "@core/features/invitation";

export function InvitationHeaderContainer() {
  const { invitation } = useInvitation();
  const location = useLocation();

  // Determine if inverted based on route (join page is the intro step)
  const isInverted = location.pathname.endsWith("/join");

  // Add "Admin" suffix for org admin invitations (both regular and primary contact)
  const suffix = invitation
    ? invitation.type === INVITATION_TYPE.ORG_ADMIN ||
      invitation.type === INVITATION_TYPE.ORG_ADMIN_PRIMARY
      ? "Admin"
      : undefined
    : undefined;

  return (
    <InvitationHeader
      organizationName={invitation?.owner_display}
      isInverted={isInverted}
      suffix={suffix}
    />
  );
}

export default InvitationHeaderContainer;


